<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="650">
      <v-card>
        <v-toolbar dense  dark color="primary">
          <v-toolbar-title>{{$t("view.comercio.title")}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-list dense three-line subheader>
            <v-subheader>{{$t("view.comercio.detalle")}}</v-subheader>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{$t("view.global.common.clave")}}</v-list-tile-title>
                <v-list-tile-sub-title>{{comercio.clave}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title>{{$t("view.comercio.numeroComercio")}}</v-list-tile-title>
                <v-list-tile-sub-title>{{comercio.numeroComercio}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title>{{$t('view.comercio.name')}}</v-list-tile-title>
                <v-list-tile-sub-title>{{comercio.name}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list three-line subheader>
            <v-subheader>{{$t("view.comercio.datosBuzonEntrada")}}</v-subheader>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{$t('view.global.common.url')}}</v-list-tile-title>
                <v-list-tile-sub-title>{{comercio.urlBuzonEntrada}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title>{{$t('view.global.common.usuario')}}</v-list-tile-title>
                <v-list-tile-sub-title>{{comercio.usuarioBuzonEntrada}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title>{{$t('view.global.common.contrasena')}}</v-list-tile-title>
                <v-list-tile-sub-title>
                  <input type="password" :value="comercio.passwordBuzonEntrada" readonly />
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <!-- <v-list three-line subheader>
            <v-subheader>{{$t("view.comercio.datosBuzonRecepcion")}}</v-subheader>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{$t('view.global.common.url')}}</v-list-tile-title>
                <v-list-tile-sub-title>{{comercio.urlBuzonRecepcion}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title>{{$t('view.global.common.usuario')}}</v-list-tile-title>
                <v-list-tile-sub-title>{{comercio.usuarioBuzonRecepcion}}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title>{{$t('view.global.common.contrasena')}}</v-list-tile-title>
                <v-list-tile-sub-title>
                  <input type="password" :value="comercio.passwordBuzonRecepcion" readonly />
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green darken-1" flat @click.native="dialog = false">Disagree</v-btn>
          <v-btn color="green darken-1" flat @click.native="dialog = false">Agree</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    data() {
      return {
        dialog : false
        , comercio : {}
      }
    }
    ,methods: {
      openDialog(){
        this.dialog = true;
      }
    }
    , mounted(){
      const vm = this;
      function emitEventOpenDoalog(event){
        const {dialog} = this;
        vm.dialog = dialog;
        vm.$emit('openDialog',dialog);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/bitacoras/documento/ModalComercio.vue